import React, { useRef, useState, useEffect } from 'react';
import cx from 'classnames';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { Container, Section } from 'components/shared';
import styled from 'styled-components';
import { isValidTitle } from 'utils/validateTitle';

import loadable from '@loadable/component';
const SmallTitleAndText = loadable(() =>
  import('components/components/molecules/SmallTitleAndText'),
);

const Img = styled.img`
  ${({ isHorizontal }) =>
    isHorizontal ? 'max-height: 6.25rem;' : 'max-height: 12.5rem;'}
`;

const SmallTitleAndTextContainer = ({ fields }) => {
  const title = getFieldValue(fields, 'heading');
  const copyText = getFieldValue(fields, 'copyText');
  const textStyle = getFieldValue(fields, 'textStyle') || '';
  const textAlignment = getFieldValue(fields, 'textAlignment');
  const shareButton = getFieldValue(fields, 'shareButton');
  const ctaLink = getFieldValue(fields, 'ctaLink');
  const ctaText = getFieldValue(fields, 'ctaText');
  const styles = textStyle.split('-') || [];
  const textColor = styles[0] || 'blue';
  const bgColor = styles[1] || 'white';

  const [isHorizontal, setIsHorizontal] = useState(false);
  const logo = getFieldValue(fields, 'logo') || {};
  const imgRef = useRef();
  useEffect(() => {
    if (imgRef.current) {
      const imgHeight = imgRef.current.naturalHeight;
      const imgWidth = imgRef.current.naturalWidth;
      setIsHorizontal(imgWidth > imgHeight);
    }
  }, [imgRef]);

  if (!isValidTitle(title) && !copyText) {
    return null;
  }

  const regex = /<a\s+[^>]*href="([^"]+\.pdf)"[^>]*>([^<]+)<\/a>/gi;
  const spanRegex =
    /<[^>]+style="font-family:\s*tahoma;\s*font-size:\s*24px;\s*color:\s*rgb\(0,\s*0,\s*0\);"[^>]*>([^<]+)<\/[^>]+>/gi;
  const spanRegexAll =
    /<span style="font-family:\s*tahoma;\s*color:\s*rgb\(0,\s*0,\s*0\);">([^<]+)<\/span>/gi;
  const updatedLink = copyText
    ? copyText
        .replace(regex, (match, href, currentText) => {
          return `<a href="${href}">Download Mattamy Homes ${currentText} PDF.</a>`;
        })
        .replace(spanRegex, (match, spanText) => {
          return `<h2 style="font-family: tahoma; color: rgb(0, 0, 0);font-weight:bold; font-size:1.125rem ;margin-bottom:12pt">${spanText}</h2>`;
        })
        .replace(spanRegexAll, (match, spanText) => {
          // Add font size 1rem to the span element
          return `<span style="font-family: tahoma; color: rgb(0, 0, 0); font-size: 1rem;">${spanText}</span>`;
        })
    : ''; // trace link with end with pdf / change capitAL to h2/  set rem for font size

  return (
    <Section
      className={cx({
        'bg-white': bgColor === 'white',
        'bg-mattamy-gray-bg': bgColor === 'gray',
        'bg-mattamy-blue': bgColor === 'blue' && textColor !== 'blue',
        'bg-light-blue': bgColor === 'blue' && textColor === 'blue',
      })}
    >
      <Container>
        {logo && logo.src && (
          <div className='flex flex-col items-center text-center'>
            <Img
              className='mb-8'
              ref={imgRef}
              isHorizontal={isHorizontal}
              src={logo.src}
              alt={logo.alt}
            />
          </div>
        )}
        <SmallTitleAndText
          title={title}
          text={updatedLink}
          textColor={textColor}
          textAlignment={textAlignment}
          showShare={shareButton}
          bgColor={bgColor}
          ctaLink={ctaLink && ctaLink.href}
          ctaText={ctaText}
          target={ctaLink && ctaLink.target}
        />
      </Container>
    </Section>
  );
};

export default SmallTitleAndTextContainer;
